/**
 *
 * @Description: Represents one legend item
 *
 */

'use strict'

import PropTypes from 'prop-types'

import React, { Component } from 'react'

export default class LegendItem extends Component {

  // prop types
  static propTypes = {
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }

  render () {
    const legendColor = {
      background: this.props.color
    }
    return (
      <div className='nmc-legend'>
        <div className='nmc-legend-color' style={legendColor} />
        <div className='nmc-legend-label'>{this.props.label}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/HorizontalLegend/LegendItem.js